const setChatUsername = (username) => {
	return {
		type: 'SET_USERNAME',
		username: username,
	};
};

const setChatEmail = (email) => {
	return {
		type: 'SET_EMAIL',
		email: email,
	};
};

const setChatUserId = (userId) => {
	return {
		type: 'SET_USER_ID',
		userId: userId,
	};
};

const setChatPrivacyLink = (privacyLink) => {
	return {
		type: 'SET_PRIVACY_LINK',
		privacyLink: privacyLink,
	};
};

const setShowMobileChat = (showMobileChat) => {
	return {
		type: 'SET_SHOW_MOBILE_CHAT',
		showMobileChat: showMobileChat,
	};
};

const setChatPrivacyText = (privacyText) => {
	return {
		type: 'SET_PRIVACY_TEXT',
		privacyText: privacyText,
	};
};

const setShowPrivacyText = (showPrivacyText) => {
	return {
		type: 'SET_SHOW_PRIVACY_TEXT',
		showPrivacyText: showPrivacyText,
	};
};

const setAgreement = (agreement) => {
	return {
		type: 'SET_AGREEMENT',
		agreement: agreement,
	};
};

const setErrorMessage = (errorMessage) => {
	return {
		type: 'SET_ERROR_MESSAGE',
		errorMessage: errorMessage,
	};
};

const setShowLoginForm = (show) => {
	return {
		type: 'SET_SHOW_LOGIN_FORM',
		show: show,
	};
};

const setRequireEmailLogin = (requireEmailLogin) => {
	return {
		type: 'SET_REQUIRE_EMAIL_LOGIN',
		requireEmailLogin: requireEmailLogin,
	};
};

const setRequireUsernameLogin = (requireUsernameLogin) => {
	return {
		type: 'SET_REQUIRE_USERNAME_LOGIN',
		requireUsernameLogin: requireUsernameLogin,
	};
};

export {
	setChatUsername,
	setChatEmail,
	setChatUserId,
	setChatPrivacyLink,
	setChatPrivacyText,
	setShowPrivacyText,
	setAgreement,
	setErrorMessage,
	setShowLoginForm,
	setRequireEmailLogin,
	setRequireUsernameLogin,
	setShowMobileChat,
};
